import { render, staticRenderFns } from "./Type4a.vue?vue&type=template&id=47876762&"
import script from "./Type4a.vue?vue&type=script&lang=js&"
export * from "./Type4a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports